'use client'

import { useEffect, Suspense } from 'react'
import { useSearchParams } from 'next/navigation'
import { SectionCards } from "@/components/section-cards"
import { AuthGuard } from "@/components/auth-guard"
import { useToast } from '@/components/ui/toast'

function DashboardContentInner() {
  const searchParams = useSearchParams()
  const { addToast } = useToast()

  useEffect(() => {
    const subscriptionComplete = searchParams.get('subscription_complete')
    const subscriptionCanceled = searchParams.get('subscription_canceled')

    if (subscriptionComplete === 'true') {
      addToast({
        title: 'Welcome! 🎉',
        message: 'Your subscription is now active. Start exploring!',
        variant: 'success',
      })
    }

    if (subscriptionCanceled === 'true') {
      addToast({
        title: 'Subscription Required',
        message: 'You must choose a plan to access the platform.',
        variant: 'error',
      })
    }
  }, [searchParams, addToast])

  return (
    <div className="flex flex-1 flex-col p-4 md:p-8">
      <SectionCards />
    </div>
  )
}

function DashboardContent() {
  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-sm text-gray-600">Loading...</p>
        </div>
      </div>
    }>
      <DashboardContentInner />
    </Suspense>
  )
}

export default function DashboardPage() {
  return (
    <AuthGuard>
      <DashboardContent />
    </AuthGuard>
  );
}
